// Modules
import Korg from 'reed-korg'
import Cookies from 'js-cookie'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { clearTimers } from '@utils/utils'


// Components
import BaseComponent from '@blocks/_BaseComponent'




/* STEP NAVIGATION
----------------------------------------------------------------------------------------------------*/

export default class StepNav extends BaseComponent {

    constructor($el, namespace) {
        super('StepNav', $el, namespace)

        this.guideID = JSON.parse(this.$el[0].dataset.guideId)
        this.stepID = JSON.parse(this.$el[0].dataset.stepId)
        this.stepsIDs = JSON.parse(this.$el[0].dataset.stepsIds)

        this.isOpen = false
        this.korg = new Korg(this.$refs.scrollArea[0])

        this.getCurrentProgress(true)
        this.initTimeline()
        this.on()
    }


    bindHandlers() {
        this.keydownHandler        = (e) => { this.onKeyDown(e) }
        this.focusinHandler        = (e) => { this.onFocusIn(e) }
        this.clickHandler          = (e) => { this.onButtonClick(e) }
        this.pageWillChangeHandler = () => { this.onPageWillChange() }
        this.resizeHandler         = () => { this.onResize() }
    }


    bindEvents() {
        const { $win, $doc } = this.$utils
        const { $toggleBtn } = this.$refs


        this.addListeners(
            // Nav events
            [$doc, 'pageWillChange', this.pageWillChangeHandler],

            // Layout events
            [$win, 'scroll', this.scrollHandler],
            [$doc, 'layoutChange', this.resizeHandler],

            // User input
            [$toggleBtn, 'click', this.clickHandler],
        )
    }




    /* Init
    --------------------------------------------------------- */

    initTimeline() {
        if (document.body.scrollHeight < APP.Layout.H + 200) {
            this.readTimer = setTimeout(() => {
                this.markAsRead()
            }, 1000)

            return
        }

        this.readTrigger = ScrollTrigger.create({
            trigger: this.$el[0].closest('.view'),
            once: true,
            start: 'top top',
            end: 'bottom 100%+=200px',
            onLeave: () => { this.markAsRead() },
        })
    }




    /* Handlers
    --------------------------------------------------------- */

    onPageWillChange() {
        if (this.readTrigger) {
            this.readTrigger.kill(true)
        }

        clearTimeout(this.readTimer)
        this.toggleNav(false)
    }


    onResize() {
        if (!this.isOpen || APP.Layout.isMobile) return
    }


    onButtonClick(e) {
        e.preventDefault()

        this.toggleNav()
    }


    onKeyDown({ key }) {
        if (key === 'Escape') {
            this.toggleNav(false)
        }
    }


    onFocusIn({ target }) {
        if (!this.isOpen) return

        if (!this.$refs.listWrapper[0].contains(target)) {
            this.toggleNav(false)
        }
    }




    /* Actions
    --------------------------------------------------------- */

    toggleNav(shouldOpen = !this.isOpen) {
        if (shouldOpen === this.isOpen) return
        const { $doc } = this.$utils

        clearTimers([this.stateTimer, this.resetTimer, this.eventTimer])

        this.isOpen = shouldOpen
        this.korg.toggle(this.isOpen)

        this.$refs.toggleBtn.attr('aria-expanded', shouldOpen)


        $doc.trigger('overlayToggled', { isOpen : this.isOpen, trigger: 'stepNav' })


        if (shouldOpen) {
            this.$el.addClass('is-open')
            this.$refs.content[0].focus()

            this.stateTimer = setTimeout(() => {
                this.$el.addClass('is-deployed no-tr')
            }, 800)

            this.eventTimer = setTimeout(() => {
                this.bindListener($doc, 'focusin', this.focusinHandler)
                this.bindListener($doc, 'keydown', this.keydownHandler)
            }, 100)
        } else {
            this.unbindListener($doc, 'focusin', this.focusinHandler)
            this.unbindListener($doc, 'keydown', this.keydownHandler)

            this.$el.removeClass('is-deployed')

            this.transitionTimer = setTimeout(() => {
                this.$el.removeClass('no-tr')
            }, 16)

            this.stateTimer = setTimeout(() => {
                this.$el.removeClass('is-open')
            }, 32)

            this.resetTimer = setTimeout(() => {
                this.$refs.scrollArea[0].scrollTo(0, 0)
            }, 600)
        }
    }


    markAsRead() {
        const { readSteps } = this.guidesProgress[this.guideID]

        // Check if step hasn’t been read already
        if (!readSteps.includes(this.stepID)) {
            this.guidesProgress[this.guideID].readSteps.push(this.stepID)
            Cookies.set('guidesProgress', JSON.stringify(this.guidesProgress), { expires: 365 })
            this.getCurrentProgress()
            if (this.guidesProgress[this.guideID].readSteps.length === this.guidesProgress[this.guideID].allSteps.length) {
                // completed -> send to datalayer
                const eventObj = {
                    event: 'smart_guide_complete',
                }
                // console.log(eventObj)
                if (typeof dataLayer !== 'undefined') { // eslint-disable-line no-undef
                    dataLayer.push(eventObj) // eslint-disable-line no-undef
                }
            }

            this.$utils.$doc.trigger('stepMarkedAsRead', { ID : this.stepID })
        }
    }




    /* Values
    --------------------------------------------------------- */

    getCurrentProgress(initial) {
        const cookie = Cookies.get('guidesProgress')
        this.guidesProgress = cookie ? JSON.parse(cookie) : {}

        const guideProgress = this.guidesProgress[this.guideID] || {}
        guideProgress.allSteps = this.stepsIDs
        guideProgress.readSteps = guideProgress.readSteps || []

        this.guidesProgress[this.guideID] = guideProgress

        this.verifiedReadSteps = guideProgress.readSteps.filter(stepID => this.stepsIDs.includes(stepID))
        this.progressPercentage = (this.verifiedReadSteps.length / this.stepsIDs.length) * 100

        this.$refs.track[0].style.setProperty('--guideProgress', `${this.progressPercentage}%`)

        if (initial) {
            Cookies.set('guidesProgress', JSON.stringify(this.guidesProgress), { expires: 365 })
        }
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



